import clsx from 'clsx';

export interface DropdownMenuItemProps {
  label: string;
  icon?: JSX.Element;
  link?: string;
  active?: boolean;
  onClick?: () => void;
  newTab?: boolean;
}

export const DropdownMenuItem = ({
  label,
  icon,
  link,
  active,
  onClick,
  newTab,
}: DropdownMenuItemProps) => {
  const EntryTag = link ? 'a' : 'button';

  return (
    <div className="w-full bg-gray-950 light:bg-white">
      <EntryTag
        {...(link && { href: link })}
        {...(link && newTab && { target: '_blank', rel: 'noopener noreferrer' })}
        onClick={(_ev) => onClick?.()}
        className={clsx(
          'flex w-full cursor-pointer items-center border-l-2 bg-gray-950 px-4 py-1.5 text-left text-sm no-underline light:bg-white',
          'hover:border-pink-400 hover:text-pink-400 light:hover:border-pink-700 light:hover:text-pink-700',
          // text-white and text-pink-400 both being present at once (one
          // from a shared base class, one from this ternary) isn't safe --
          // Tailwind doesn't resolve conflicting utilities by className
          // order, so which one actually renders depends on generated
          // stylesheet order, not this ternary. Each branch here now
          // supplies its own, single text-color class instead.
          active
            ? 'border-pink-400 text-pink-400 light:border-pink-700 light:text-pink-700'
            : 'border-gray-950 text-white light:border-white light:text-gray-900',
        )}
      >
        {icon && <span className="mr-2">{icon}</span>}
        <span>{label}</span>
      </EntryTag>
    </div>
  );
};
